<div id="ajax-container" class="col-md-8">
    <div class="row" *ngIf="lengthPages + lengthFaq == 0 && !isSearchTouched">
        <div class="col-md-12">
            <div class="widget-main">
                <div class="widget-inner">
                    <p>Leider wurden keine Ergebnisse zu Ihrer Suche gefunden.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="row masonry">
        <div class="col-sm-6">
            <div class="masonry-panel" *ngFor="let result of results">
                <div class="page type-page status-publish hentry ">
                    <div class="blog-grid-item masonry-item">
                        <div class="box-content-inner">
                            <h4 class="blog-grid-title">
                                <a class="search-title" routerLink="/{{result.name}}">{{ result.titel }}</a>
                            </h4>
                            <p class="blog-grid-meta small-text">
                                <span></span>
                            </p>
                            <p>{{ result.seite }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="masonry-panel" *ngFor="let result of resultFaq">
                <div class="page type-page status-publish hentry ">
                    <div class="blog-grid-item masonry-item">
                        <div class="box-content-inner">
                            <h4 class="blog-grid-title">
                                <a class="search-title" href="/faq#{{result.index}}">{{ result.frage }}</a>
                            </h4>
                            <p class="blog-grid-meta small-text">
                                <span></span>
                            </p>
                            <p>{{ result.antwort }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="maxLength > 10 && lengthPages + lengthFaq < maxLength">
        <div class="col-md-12">
            <div class="load-more-btn">
                <a id="load-more-btn" (click)="loadMore()">Mehr laden</a>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="lengthPages + lengthFaq == maxLength && maxLength > 10">
        <div class="col-md-12">
            <div class="no-more-items">
                <p>Keine weiteren Suchergebnisse</p>
            </div>
        </div>
    </div>
</div>

